import { useEffect, useState } from "react";

import api from "@helpers/api";
import { Pagination } from "@type/procurements/pagination";

type Products = {
  [kay: string]: any;
  error: any;
  isLoading: boolean;
  getData: { data: []; pagination: Pagination } | null;
};

interface UseProductList {
  products: Products;
  handleQuery: (key: string, value: number | string) => void;
}

export const useProductsList = (): UseProductList => {
  const [products, setProducts] = useState<Products>({
    getData: null,
    error: null,
    isLoading: false,
  });

  const [query, setQuery] = useState({
    page: 1,
    size: 10,
    search: "",
  });

  const handleQuery = (key: string, value: number | string) =>
    setQuery((prev) => ({
      ...prev,
      [key]: value,
    }));

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await api.get(
          `${process.env.REACT_APP_EMPLOYEE_INVENTORY_SERVICE_BASE_URL}${process.env.REACT_APP_EMPLOYEE_INVENTORY_SERVICE_PORT}/${process.env.REACT_APP_EMPLOYEE_INVENTORY_SERVICE}/api/${process.env.REACT_APP_EMPLOYEE_INVENTORY_SERVICE_VERSION}/${process.env.REACT_APP_EMPLOYEE_INVENTORY_SERVICE_TYPE}/settings/product-name`,
          {
            params: query,
          },
        );

        const { data, page, size, total } = res.data || {};

        setProducts((prev: Products) => ({
          ...prev,
          isLoading: false,
          getData: {
            data,
            pagination: {
              page,
              size,
              total,
            },
          },
        }));
      } catch (err) {
        setProducts((prev: Products) => ({
          ...prev,
          isLoading: false,
          getData: null,
          error: err,
        }));
      }
    };

    fetchData();
  }, [query]);

  return {
    handleQuery,
    products,
  };
};
